/**
 * Stable CSS class names for E2E — StoreDeliveryOrders page.
 * Used by the test automation team as deterministic selectors.
 * Containers use `store-delivery-orders__<element>`; inputs and
 * user-interactable controls use `store-delivery-orders-input--<name>`.
 */
export const SDO = {
    page: 'store-delivery-orders-page',
    root: 'store-delivery-orders',

    header: 'store-delivery-orders__header',
    title: 'store-delivery-orders__title',
    loading: 'store-delivery-orders__loading',

    grid: 'store-delivery-orders__grid',

    cellStoreCode: 'store-delivery-orders__cell-store-code',
    cellCustomerName: 'store-delivery-orders__cell-customer-name',
    cellOrderNumber: 'store-delivery-orders__cell-order-number',
    cellShippingNo: 'store-delivery-orders__cell-shipping-no',
    /** Clickable link inside the shipping-no cell. */
    cellShippingNoLink: 'store-delivery-orders-input--cell-shipping-no-link',
    cellShippingStatus: 'store-delivery-orders__cell-shipping-status',
    cellOrderDate: 'store-delivery-orders__cell-order-date',
    cellDeliveryDate: 'store-delivery-orders__cell-delivery-date',

    cellActions: 'store-delivery-orders__cell-actions',
    btnRowMenu: 'store-delivery-orders-input--button-row-menu',
    rowMenu: 'store-delivery-orders__row-menu',
    rowMenuItem: 'store-delivery-orders__row-menu-item',
    rowMenuItemReturn: 'store-delivery-orders__row-menu-item--return',
    rowMenuItemDetail: 'store-delivery-orders__row-menu-item--detail',
} as const;

export const sdoCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
